"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FoodOutOfStockSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M11.1387339,15.1449855 L12.767767,13.4748737 L11.1489997,11.8425003 C10.9575229,11.6494141 10.9567326,11.338307 11.1472258,11.1442505 C11.3357281,10.9522221 11.6442093,10.9493636 11.8362377,11.1378659 L13.4748737,12.767767 L15.1081179,11.1669275 C15.3072291,10.9717669 15.6257416,10.9713066 15.825416,11.1658909 C16.0212046,11.3566884 16.0252507,11.6700784 15.8344531,11.865867 L15.8299223,11.8704562 L14.232233,13.467767 L15.8350323,15.1232873 C16.0292635,15.3239074 16.02748,15.6429946 15.8310183,15.8414308 C15.637404,16.036991 15.3219157,16.0385685 15.1263555,15.8449542 L15.1233672,15.8419705 L13.4748737,14.1819805 L11.8371831,15.8464826 C11.6478452,16.0389203 11.3383548,16.0414332 11.1459171,15.8520952 C10.9490685,15.6544138 10.9474631,15.3410795 11.1387339,15.1449855 Z M9,15 L2,15 L2,14 L3,14 L3,11.5 C3,8.63097872 5.19674999,6.2750359 8,6.02242151 L8,5 L7,5 L7,4 L10,4 L10,5 L9,5 L9,6.02242151 C10.9262117,6.19600174 12.5660615,7.36267846 13.4036181,9.0065203 C12.8672178,9.00723265 12.5,9.00723265 12.2470568,9.00723265 C11.4404562,7.79718988 10.0633249,7 8.5,7 C6.01471863,7 4,9.01471863 4,11.5 C4,11.6126697 4.00168096,12.446003 4.00504288,14 L9,14 L9,15 Z" })));
};
FoodOutOfStockSmall.displayName = 'FoodOutOfStockSmall';
exports.default = FoodOutOfStockSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FoodOutOfStockSmall.js.map